import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Resdit7421PerformanceReport from '../../components/Resdit7421PerformanceReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/Resdit7421PerformanceDetailsSelectors';

export function Resdit7421PerformanceDetailsContainer(props) {
  return (
    <Resdit7421PerformanceReport
      reportId={ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_107B.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

Resdit7421PerformanceDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(Resdit7421PerformanceDetailsContainer);
